(function(){
  var selector = '.amz-grid-swatches';

  function ensureCollapseStyles(){
    if(document.getElementById('amz-grid-swatches-collapse-fix')) return;
    var style = document.createElement('style');
    style.id = 'amz-grid-swatches-collapse-fix';
    style.textContent = '.amz-grid-swatches.is-expanded .amz-grid-swatches__viewport{overflow:visible!important;width:100%!important;max-width:100%!important}.amz-grid-swatches.is-expanded .amz-grid-swatches__track{display:flex!important;flex-wrap:wrap!important;width:100%!important;max-width:100%!important}.amz-grid-swatches.is-expanded .amz-grid-swatch.is-collapsed{display:inline-flex!important}.amz-grid-swatches.is-expanded .amz-grid-swatches__nav{display:none!important}@media(max-width:768px){.amz-grid-swatches[data-swatch-collapse="true"][data-collapse-device="mobile"]:not(.is-expanded) .amz-grid-swatch.is-collapsed,.amz-grid-swatches[data-swatch-collapse="true"][data-collapse-device="both"]:not(.is-expanded) .amz-grid-swatch.is-collapsed{display:none!important}.amz-grid-swatches[data-swatch-collapse="true"][data-collapse-device="mobile"]:not(.is-expanded) .amz-grid-swatch-more,.amz-grid-swatches[data-swatch-collapse="true"][data-collapse-device="both"]:not(.is-expanded) .amz-grid-swatch-more{display:inline-flex!important}.amz-grid-swatches[data-swatch-collapse="true"][data-collapse-device="mobile"].is-expanded .amz-grid-swatch-less,.amz-grid-swatches[data-swatch-collapse="true"][data-collapse-device="both"].is-expanded .amz-grid-swatch-less{display:inline-flex!important}.amz-grid-swatches[data-swatch-collapse="true"][data-collapse-device="mobile"].is-expanded .amz-grid-swatch-more,.amz-grid-swatches[data-swatch-collapse="true"][data-collapse-device="both"].is-expanded .amz-grid-swatch-more{display:none!important}}@media(min-width:769px){.amz-grid-swatches[data-swatch-collapse="true"][data-collapse-device="desktop"]:not(.is-expanded) .amz-grid-swatch.is-collapsed,.amz-grid-swatches[data-swatch-collapse="true"][data-collapse-device="both"]:not(.is-expanded) .amz-grid-swatch.is-collapsed{display:none!important}.amz-grid-swatches[data-swatch-collapse="true"][data-collapse-device="desktop"]:not(.is-expanded) .amz-grid-swatch-more,.amz-grid-swatches[data-swatch-collapse="true"][data-collapse-device="both"]:not(.is-expanded) .amz-grid-swatch-more{display:inline-flex!important}.amz-grid-swatches[data-swatch-collapse="true"][data-collapse-device="desktop"].is-expanded .amz-grid-swatch-less,.amz-grid-swatches[data-swatch-collapse="true"][data-collapse-device="both"].is-expanded .amz-grid-swatch-less{display:inline-flex!important}.amz-grid-swatches[data-swatch-collapse="true"][data-collapse-device="desktop"].is-expanded .amz-grid-swatch-more,.amz-grid-swatches[data-swatch-collapse="true"][data-collapse-device="both"].is-expanded .amz-grid-swatch-more{display:none!important}}';
    document.head.appendChild(style);
  }

  function qsa(root, sel){
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function isMobile(){
    return window.matchMedia('(max-width: 768px)').matches;
  }

  function modeActive(root){
    var mode = root.getAttribute('data-swipe-mode') || 'disabled';
    if(mode === 'disabled') return false;
    if(mode === 'both') return true;
    if(mode === 'mobile') return isMobile();
    if(mode === 'desktop') return !isMobile();
    return false;
  }

  function collapseActive(root){
    if(String(root.getAttribute('data-swatch-collapse')) !== 'true') return false;
    var device = root.getAttribute('data-collapse-device') || 'desktop';
    if(device === 'disabled') return false;
    if(device === 'both') return true;
    if(device === 'mobile') return isMobile();
    if(device === 'desktop') return !isMobile();
    return false;
  }

  function smoothEnabled(root){
    return String(root.getAttribute('data-smooth-scroll')) !== 'false';
  }

  function cardFrom(root){
    return root.closest('.amz-gp') || root.closest('.grid__item');
  }

  function mainImage(card){
    if(!card) return null;
    return card.querySelector('.amz-gp__img-mask img') || card.querySelector('.grid__item-image-wrapper img') || card.querySelector('img');
  }

  function storeImage(img){
    if(!img || img.dataset.amzOriginalSrc) return;
    img.dataset.amzOriginalSrc = img.getAttribute('src') || '';
    img.dataset.amzOriginalSrcset = img.getAttribute('srcset') || '';
    img.dataset.amzOriginalDataSrc = img.getAttribute('data-src') || '';
    img.dataset.amzOriginalDataSrcset = img.getAttribute('data-srcset') || '';
  }

  function imageChanging(card){
    if(!card) return;
    card.classList.add('is-amz-swatch-image-changing');
    window.clearTimeout(card.__amzSwatchImageTimer);
    card.__amzSwatchImageTimer = window.setTimeout(function(){
      card.classList.remove('is-amz-swatch-image-changing');
    }, 180);
  }

  function swapImage(card, url){
    if(!card || !url) return;
    var img = mainImage(card);
    if(!img) return;
    storeImage(img);
    imageChanging(card);
    window.setTimeout(function(){
      img.setAttribute('src', url);
      img.setAttribute('srcset', url);
      img.removeAttribute('data-src');
      img.removeAttribute('data-srcset');
      img.loading = 'eager';
      if(img.closest('amz-img-el')) img.closest('amz-img-el').classList.add('loaded');
    }, 60);
  }

  function restoreImage(card){
    if(!card) return;
    var active = card.querySelector('.amz-grid-swatch.is-active[data-variant-image]');
    if(active && active.getAttribute('data-variant-image')){
      swapImage(card, active.getAttribute('data-variant-image'));
      return;
    }
    var img = mainImage(card);
    if(!img || !img.dataset.amzOriginalSrc) return;
    imageChanging(card);
    window.setTimeout(function(){
      img.setAttribute('src', img.dataset.amzOriginalSrc);
      if(img.dataset.amzOriginalSrcset) img.setAttribute('srcset', img.dataset.amzOriginalSrcset);
      if(img.dataset.amzOriginalDataSrc) img.setAttribute('data-src', img.dataset.amzOriginalDataSrc);
      if(img.dataset.amzOriginalDataSrcset) img.setAttribute('data-srcset', img.dataset.amzOriginalDataSrcset);
    }, 60);
  }

  function updateLinks(card, swatch){
    if(!card || !swatch) return;
    var url = swatch.getAttribute('data-variant-url');
    if(!url) return;
    qsa(card, '.amz-gp__lnk').forEach(function(link){
      link.setAttribute('href', url);
    });
  }

  function selectSwatch(root, swatch){
    if(!root || !swatch) return;
    qsa(root, '.amz-grid-swatch').forEach(function(btn){
      btn.classList.remove('is-active');
      btn.setAttribute('aria-pressed', 'false');
    });
    swatch.classList.add('is-active');
    swatch.setAttribute('aria-pressed', 'true');
    var card = cardFrom(root);
    swapImage(card, swatch.getAttribute('data-variant-image'));
    updateLinks(card, swatch);
  }

  function isMobileCollection(){
    return document.body && document.body.classList.contains('template-collection') && window.matchMedia('(max-width: 768px)').matches;
  }

  function previewSwatch(root, swatch){
    if(!root || !swatch) return;
    if(isMobileCollection()) return;
    if(String(root.getAttribute('data-hover-preview')) === 'false') return;
    swapImage(cardFrom(root), swatch.getAttribute('data-variant-image'));
  }

  function updateCollapse(root){
    var active = collapseActive(root);
    root.classList.toggle('amz-swatch-collapse-active', active);
    if(!active) root.classList.remove('is-expanded');
    return active;
  }

  function updateArrows(root){
    var viewport = root.querySelector('.amz-grid-swatches__viewport');
    var prev = root.querySelector('.amz-grid-swatches__nav--prev');
    var next = root.querySelector('.amz-grid-swatches__nav--next');
    var collapsedNow = updateCollapse(root);
    var active = modeActive(root) && !(collapsedNow && root.classList.contains('is-expanded'));
    root.classList.toggle('amz-swatch-swipe-active', active);
    if(!viewport || !prev || !next) return;

    if(!active){
      viewport.scrollLeft = 0;
      prev.style.display = 'none';
      next.style.display = 'none';
      prev.classList.add('is-disabled');
      next.classList.add('is-disabled');
      return;
    }

    var maxScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
    var hasOverflow = maxScroll > 2;
    var showArrows = hasOverflow && root.getAttribute('data-swipe-arrows') !== 'false';

    prev.style.display = showArrows ? 'inline-flex' : 'none';
    next.style.display = showArrows ? 'inline-flex' : 'none';

    if(!hasOverflow){
      prev.classList.add('is-disabled');
      next.classList.add('is-disabled');
      return;
    }

    var current = Math.max(0, viewport.scrollLeft || 0);
    prev.classList.toggle('is-disabled', current <= 2);
    next.classList.toggle('is-disabled', current >= maxScroll - 2);
  }

  function scrollStep(root){
    var viewport = root.querySelector('.amz-grid-swatches__viewport');
    var first = root.querySelector('.amz-grid-swatch:not(.is-collapsed)') || root.querySelector('.amz-grid-swatch');
    if(!viewport || !first) return 80;
    var styles = window.getComputedStyle(root);
    var gap = parseFloat(styles.getPropertyValue('--amz-grid-swatch-gap')) || 0;
    var per = isMobile() ? parseInt(root.getAttribute('data-per-view-mobile') || '3', 10) : parseInt(root.getAttribute('data-per-view-desktop') || '6', 10);
    per = Math.max(1, Math.min(12, per || 3));
    return (first.getBoundingClientRect().width + gap) * per;
  }

  function scrollNav(root, dir){
    var viewport = root.querySelector('.amz-grid-swatches__viewport');
    if(!viewport || !modeActive(root)) return;
    var maxScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
    var nextLeft = Math.max(0, Math.min(maxScroll, (viewport.scrollLeft || 0) + (dir * scrollStep(root))));
    if(smoothEnabled(root) && viewport.scrollTo){
      viewport.scrollTo({ left: nextLeft, behavior: 'smooth' });
    }else{
      viewport.scrollLeft = nextLeft;
    }
    window.requestAnimationFrame(function(){ updateArrows(root); });
    window.setTimeout(function(){ updateArrows(root); }, 120);
    window.setTimeout(function(){ updateArrows(root); }, 320);
  }

  function initOne(root){
    if(!root || root.dataset.amzSwInit === '1'){
      if(root) updateArrows(root);
      return;
    }
    root.dataset.amzSwInit = '1';
    var active = root.querySelector('.amz-grid-swatch.is-active') || root.querySelector('.amz-grid-swatch');
    if(active){
      active.classList.add('is-active');
      active.setAttribute('aria-pressed', 'true');
      updateLinks(cardFrom(root), active);
    }

    root.addEventListener('click', function(e){
      var more = e.target.closest('.amz-grid-swatch-more');
      var less = e.target.closest('.amz-grid-swatch-less');
      var prev = e.target.closest('.amz-grid-swatches__nav--prev');
      var next = e.target.closest('.amz-grid-swatches__nav--next');
      var swatch = e.target.closest('.amz-grid-swatch');

      if(more){
        e.preventDefault();
        e.stopPropagation();
        root.classList.add('is-expanded');
        root.classList.add('amz-swatch-collapse-active');
        updateArrows(root);
        return;
      }

      if(less){
        e.preventDefault();
        e.stopPropagation();
        root.classList.remove('is-expanded');
        updateArrows(root);
        return;
      }

      if(prev){
        e.preventDefault();
        scrollNav(root, -1);
        return;
      }

      if(next){
        e.preventDefault();
        scrollNav(root, 1);
        return;
      }

      if(swatch){
        e.preventDefault();
        selectSwatch(root, swatch);
      }
    });

    root.addEventListener('mouseover', function(e){
      var swatch = e.target.closest('.amz-grid-swatch');
      if(swatch) previewSwatch(root, swatch);
    });

    root.addEventListener('focusin', function(e){
      var swatch = e.target.closest('.amz-grid-swatch');
      if(swatch) previewSwatch(root, swatch);
    });

    root.addEventListener('mouseleave', function(){
      restoreImage(cardFrom(root));
    });

    var viewport = root.querySelector('.amz-grid-swatches__viewport');
    if(viewport){
      var scrollTimer = 0;
      viewport.addEventListener('scroll', function(){
        window.clearTimeout(scrollTimer);
        window.requestAnimationFrame(function(){ updateArrows(root); });
        scrollTimer = window.setTimeout(function(){ updateArrows(root); }, 90);
      }, { passive: true });
      viewport.addEventListener('touchend', function(){ window.setTimeout(function(){ updateArrows(root); }, 80); }, { passive: true });
      viewport.addEventListener('pointerup', function(){ window.setTimeout(function(){ updateArrows(root); }, 80); }, { passive: true });
    }

    updateArrows(root);
    window.setTimeout(function(){ updateArrows(root); }, 120);
    window.setTimeout(function(){ updateArrows(root); }, 350);
    window.setTimeout(function(){ updateArrows(root); }, 900);
  }

  function init(root){
    ensureCollapseStyles();
    qsa(root || document, selector).forEach(initOne);
  }

  var resizeTimer = 0;
  function updateAll(){
    qsa(document, selector).forEach(function(root){
      updateArrows(root);
    });
  }

  window.addEventListener('resize', function(){
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(updateAll, 120);
  }, { passive: true });

  window.addEventListener('orientationchange', function(){
    window.setTimeout(updateAll, 250);
  }, { passive: true });

  if(document.head) ensureCollapseStyles();
  document.addEventListener('DOMContentLoaded', function(){ init(document); });
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
  document.addEventListener('recommendations:loaded', function(e){ init(e.detail && e.detail.section ? e.detail.section : document); });

  var mutationFrame = 0;
  var observer = new MutationObserver(function(mutations){
    var shouldInit = false;
    for(var i = 0; i < mutations.length; i += 1){
      if(mutations[i].addedNodes && mutations[i].addedNodes.length){
        shouldInit = true;
        break;
      }
    }
    if(!shouldInit) return;
    if(mutationFrame) window.cancelAnimationFrame(mutationFrame);
    mutationFrame = window.requestAnimationFrame(function(){
      mutationFrame = 0;
      init(document);
    });
  });

  if(document.body){
    observer.observe(document.body, { childList: true, subtree: true });
  }else{
    document.addEventListener('DOMContentLoaded', function(){
      observer.observe(document.body, { childList: true, subtree: true });
    });
  }
})();
